export const serialTypes = [
    { key: "aa5f096a-9409-11ed-a1eb-0242ac121421", value: "1", label: "کمپرسور", id: "1310" },
    { key: "aa5f0c30-9409-11ed-a1eb-0242ac121422", value: "2", label: "کمپرسور توربینی", id: "1372" },
    { key: "aa5f0d7a-9409-11ed-a1eb-0242ac121423", value: "3", label: "درایر", id: "1314" },
    { key: "aa5f0d7a-9409-11ed-a1eb-0242ac121424", value: "4", label: "درایر ASME", id: "1313" },
    { key: "aa5f0d7a-9409-11ed-a1eb-0242ac121425", value: "5", label: "اکسیژن ساز", id: "1320" },
    { key: "aa5f0d7a-9409-11ed-a1eb-0242ac121425", value: "5", label: "نیتروژن ساز", id: "1319" },
    { key: "aa5f0d7a-9409-11ed-a1eb-0242ac121425", value: "5", label: "مخزن هوای فشرده", id: "1309" },
    { key: "aa5f0d7a-9409-11ed-a1eb-0242ac121425", value: "5", label: "کول تاور", id: "1346" },
    { key: "aa5f0d7a-9409-11ed-a1eb-0242ac121425", value: "5", label: "تله آبگیر", id: "1321" },
];

export function getSerialTypes() {
    return serialTypes.filter((g) => g);
}

export function getSerialTypeById(id) {
    if (id === "none")
        return serialTypes;
    return serialTypes.filter(m => m.id === id);
}

